import TextBox from "../../../_common/components/textBox/textBox";
import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { RadioCheckbox } from "../../../_common/forms/components/components";
import { t } from "../../../_i18n";
import "./card.scss";

export default function Card({ certificate, check, setCheck, detail, setDetail, setBuy }) {
    /** Variables **/
    const [animationClass, setAnimationClass] = useState("");
    const [eventAvailable, setEventAvailable] = useState(false);

    /** Lifecycles **/
    useEffect(() => {
        if (detail) {
            setAnimationClass("opening");
        } else {
            setAnimationClass("closing");
        }
    }, [detail]);
    useEffect(() => {
        setEventAvailable(certificate?.events?.length ?? 0);
    }, [certificate])

    /** Methods **/
    const handleCardClick = (e) => {
        if (!eventAvailable) return;
        e.stopPropagation();
        setCheck(certificate?.id);
        !check && setDetail(null);
    };
    const handleDetailClick = (e) => {
        e.stopPropagation();
        setDetail(!detail ? certificate?.id : null);
        setCheck(certificate?.id);
    };
    const shouldShowBuyButton = () => {
        return (certificate?.events.length > 0) && !certificate?.events?.some(evt => evt.is_enrolled);
    };

    const hasEnrollment = () => {
        return (certificate?.events.length > 0) && certificate?.events?.some(evt => evt.is_enrolled);
    };

    const getEnrolledEventCalendar = () => {
        const enrolledEvent = certificate?.events?.find(event => event.is_enrolled);
        return enrolledEvent?.event_calendars?.[0] || null;
    };

    const shouldShowPaidTag = (event) => {
        return event.is_enrolled;
    };

    const eventExpired = (event) => {
        const eventDate = new Date(event?.end_date_join?.date);
        const now = new Date();

        return now > eventDate;
    };

    const getPrice = () => {
        return certificate?.attempt?.cost;
    };
    const getDate = (input) => {
        const date = input?.date ? input?.date : input;
        const parsedDate = new Date(date?.replace(" ", "T"));
        const yyyy = parsedDate.getFullYear();
        const mm = String(parsedDate.getMonth() + 1).padStart(2, "0");
        const dd = String(parsedDate.getDate()).padStart(2, "0");
        const hh = String(parsedDate.getHours()).padStart(2, "0");
        const min = String(parsedDate.getMinutes()).padStart(2, "0");
        return {
            date: `${dd}-${mm}-${yyyy}`,
            time: `${hh}:${min}`,
        };
    };
    const handleBuyClick = (data) => {
        setBuy(data);
    }

    const enrolledEventCalendar = getEnrolledEventCalendar();

    /** Render **/
    return (
        <div className="p-left p-right p-bottom">
            <div
                className={`card-dashboard-full-width border-hover d-flex flex-center-y no-padding ${(hasEnrollment() || check) ? "selected-border" : ""}`}
                onClick={handleCardClick}
            >
                <div className="d-flex p-all flex-space-between full-width flex-column sm-no-flex-column gap">
                    <div className="d-flex flex-center-y">
                        {eventAvailable ?
                            <RadioCheckbox
                                type="radio"
                                className="ml"
                                checked={hasEnrollment() || check}
                            /> : null
                        }
                        <div class="d-flex flex-column gap">
                            <h2>
                                {certificate?.name} <span className="font-color-879CA1 font-12">({certificate?.code})</span>
                            </h2>
                            {eventAvailable ?
                                <div className="d-flex flex-space-between gap full-width">
                                    <p className="font-32 line-height-28 no-margin p-top font-bold no-padding font-color-008FB0 flex-align-self-center">
                                        {getPrice() === 0 ? t("Gratis") : getPrice()}
                                        {getPrice() ? <span className="font-18">€</span> : null}
                                    </p>
                                    {hasEnrollment() && enrolledEventCalendar &&
                                        <TextBox className="full-width sm-fit-width background-FFFFFF font-color-black border-gray-border-color border-1">
                                            <div className="p-all-half d-flex flex-baseline-y font-color-black">
                                                <i className="fal fa-calendar-alt m-l-half" />
                                                <div className="m-l-half ">
                                                    {enrolledEventCalendar && getDate(enrolledEventCalendar?.formatted_start_date).date} {enrolledEventCalendar && getDate(enrolledEventCalendar?.formatted_start_date).time} – {enrolledEventCalendar && getDate(enrolledEventCalendar?.end_date).time}
                                                </div>
                                            </div>
                                        </TextBox>
                                    }
                                </div> : null
                            }
                        </div>
                    </div>
                    {eventAvailable ? (
                        <div className="d-flex flex-column gap sm-no-flex-row full-width sm-no-full-width flex-align-self-end">
                            <button
                                className="btn btn-ghost"
                                onClick={handleDetailClick}
                            >
                                {detail ? t("Ocultar") : t("Ver")} {t("detalle")}
                            </button>
                            {hasEnrollment() && enrolledEventCalendar &&
                                <p className="paid-border width-fit-content">
                                    <span>
                                        {t("PAGADO")}
                                    </span>
                                </p>
                            }
                        </div>
                    ) : (
                        <div className="d-flex flex-center-y">
                            <TextBox className="full-width sm-fit-width">
                                <div className="p-all-half d-flex flex-baseline-y">
                                    <i className="fal fa-calendar-alt m-l-half font-color-879CA1" />
                                    <div className="m-l-half">{t("Proximamente")}</div>
                                </div>
                            </TextBox>
                        </div>
                    )}
                </div>
                {certificate?.events.map(event =>
                    <div className={`detail-content ${animationClass}`}>
                        <div className="card-detail-dashboard d-flex flex-center-y no-padding background-F8F8F7 cursor-default">
                            <div className="p-all full-width">
                                <div className="d-flex gap flex-center-y sm-no-flex-column flex-column flex-space-between">
                                    <p className="font-16 font-bold no-margin">
                                        {t("Plazo abierto para la inscripción del certificado")}
                                    </p>
                                    <div className="d-flex flex-center-y">
                                        <TextBox className="full-width sm-fit-width background-FFFFFF font-color-black border-gray-border-color border-1">
                                            <div className="p-all-half d-flex flex-baseline-y font-color-black">
                                                <i className="fal fa-calendar-alt m-l-half" />
                                                <div className="m-l-half">
                                                    {t("Desde")} <span>{getDate(event?.start_date_join).date}</span> {t("hasta")} <span>{getDate(event?.end_date_join).date}</span>
                                                </div>
                                            </div>
                                        </TextBox>
                                    </div>
                                </div>
                                <hr className="hr-divider m-top m-bottom" />
                                {certificate.is_exception ?
                                    <div className="d-flex flex-column flex-bottom">
                                        <div>
                                            {t("English for IT.part1")}
                                            <strong>{t("English for IT.bold")}</strong>
                                            {t("English for IT.part2")}
                                            <strong>{t("English for IT.bold2")}</strong>
                                            {t("English for IT.part3")}
                                            <strong>{t("English for IT.bold3")}</strong>
                                            {t("English for IT.part4")}
                                        </div>
                                        {!shouldShowPaidTag(event) && !eventExpired(event) &&
                                            <button className="btn btn-primary" onClick={() => handleBuyClick({ certificate, event, eventCalendar: event.event_calendars[0] })}>
                                                {getPrice() === 0 ? t("Reservar") : t("Comprar")}
                                            </button>
                                        }
                                    </div> :
                                    <div className="d-flex flex-column gap">
                                        {event.event_calendars?.map((eventCalendar) => (
                                            <div className="d-flex flex-space-between flex-center-y sm-no-flex-column flex-column gap">
                                                <p className="font-16 font-bold no-margin sm-t-left t-center">
                                                    {t("Horarios prueba certificado")}
                                                </p>
                                                <p className="no-margin d-flex gap">
                                                    <div className="d-flex flex-center-y">
                                                        <TextBox className="full-width sm-fit-width background-FFFFFF font-color-black border-gray-border-color border-1">
                                                            <div className="p-all-half d-flex flex-baseline-y font-color-black">
                                                                <i className="fal fa-calendar-alt m-l-half" />
                                                                <div className="m-l-half ">
                                                                    {getDate(eventCalendar?.formatted_start_date).date} {getDate(eventCalendar?.formatted_start_date).time} – {getDate(eventCalendar?.end_date).time}
                                                                </div>
                                                            </div>
                                                        </TextBox>
                                                    </div>
                                                    {shouldShowBuyButton() && !eventExpired(event) &&
                                                        <button className="btn btn-primary" onClick={() => handleBuyClick({ certificate, event, eventCalendar })}>
                                                            {getPrice() === 0 ? t("Reservar") : t("Comprar")}
                                                        </button>
                                                    }
                                                    {shouldShowPaidTag(event) &&
                                                        <p className="paid-border flex-align-self-center">
                                                            <span>
                                                                {t("PAGADO")}
                                                            </span>
                                                        </p>

                                                    }
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
